import React from 'react'

const Blogcont = () => {
  return (
<>
 
<div class="banner-top">
  <img src="/favicon.png" alt="" />
  <img class="lo"src="http://localhost:3000/static/media/Header_Logo.5dc9c8f593f2e7d8e951.png" alt="" />
  
  <p>LET'S LEVEL UP YOUR PARTY</p>
</div>

<section class="content-wrap">
  <div class="content-grid">

    <article class="post-box">
      <img src="https://asset.gecdesigns.com/img/wallpapers/happy-birthday-wishes-delicious-cake-with-balloons-on-a-yellow-background-sr02012508-cover.webp" alt="" />
      <h2 class="post-heading">A Birthday is More than Cake and Candles</h2>
      <p class="post-time">August 22, 2025</p>
      <p class="post-preview">A birthday is about memories created with shared laughter and the realization of good times...</p>
      <a href="#" class="btn-link">Read More</a>
    </article>

    <article class="post-box">
      <img src="https://static.vecteezy.com/system/resources/previews/028/898/061/non_2x/happy-ganesh-chaturthi-festival-celebration-background-vector.jpg" alt="" />
      <h2 class="post-heading">Mumbai and Ganesh Chaturthi Celebration</h2>
      <p class="post-time">July 30, 2025</p>
      <p class="post-preview">Mumbai doesn't just celebrate Ganesh Chaturthi, it breathes it...</p>
      <a href="#" class="btn-link">Read More</a>
    </article>

    <article class="post-box">
      <img src="https://img.freepik.com/free-vector/happy-raksha-bandhan-red-background-with-decorative-rakhi_1017-19882.jpg" alt="" />
      <h2 class="post-heading">Heart-Touching Raksha Bandhan Quotes</h2>
      <p class="post-time">August 10, 2025</p>
      <p class="post-preview">Some bonds don't need daily calls or regular check-ins...</p>
      <a href="#" class="btn-link">Read More</a>
    </article>

    <article class="post-box">
      <img src="https://cdn.shopify.com/s/files/1/2338/2917/articles/Linda_GenderReveal_10_26_2018-18.jpg?v=1588126424" alt="" />
      <h2 class="post-heading">Baby Showers: Celebrating Motherhood</h2>
      <p class="post-time">August 15, 2025</p>
      <p class="post-preview">Baby showers express love for the unborn baby...</p>
      <a href="#" class="btn-link">Read More</a>
    </article>

    <article class="post-box">
      <img src="https://haplun.in/uploads/2024/07/anniversary-decoration-with-hotel-306117340_large.webp" alt="" />
      <h2 class="post-heading">Luxury Hotel Room Anniversary Decoration Ideas</h2>
      <p class="post-time">August 25, 2025</p>
      <p class="post-preview">Your first anniversary is pure joy...</p>
      <a href="#" class="btn-link">Read More</a>
    </article>

    <article class="post-box">
      <img src="https://balloonexpress.ca/cdn/shop/articles/birthday_balloons_1024x.jpeg?v=1517909511" alt="" />
      <h2 class="post-heading">5 Reasons to Hire a Professional Decorator</h2>
      <p class="post-time">August 25, 2025</p>
      <p class="post-preview">Balloons are not just for birthdays – they are the glitter, the pizzazz...</p>
      <a href="#" class="btn-link">Read More</a>
    </article>

    <article class="post-box">
      <img src="https://www.marriagecolours.com/wp-content/uploads/2025/06/Priyanka-sashi-haldi-temple-bay-1.jpg" alt="" />
      <h2 class="post-heading">How Bollywood Weddings Influence Haldi Decor</h2>
      <p class="post-time">August 25, 2025</p>
      <p class="post-preview">Bollywood sets so many trends for weddings, birthdays, and anniversaries...</p>
      <a href="#" class="btn-link">Read More</a>
    </article>

    <article class="post-box">
      <img src="https://blogcdn.aakash.ac.in/wordpress_media/2022/06/father-day-350x250.jpg" alt="" />
      <h2 class="post-heading">50 Heart Touching Fathers Day Quotes</h2>
      <p class="post-time">August 25, 2025</p>
      <p class="post-preview">Father’s Day is more than just a day in the calendar...</p>
      <a href="#" class="btn-link">Read More</a>
    </article>

    <article class="post-box">
      <img src="https://www.juliacharleseventmanagement.co.uk/wp-content/uploads/2023/08/Outdoors-To-Indoors-Enchanted-Garden-1024x576.jpg" alt="" />
      <h2 class="post-heading">Indoor vs Outdoor Kids Birthday Decoration</h2>
      <p class="post-time">August 25, 2025</p>
      <p class="post-preview">Planning a child’s birthday is a mix of joy and creativity...</p>
      <a href="#" class="btn-link">Read More</a>
    </article>

  </div>

  <div class="sidebar-box">
    <div class="search-widget">
      <input type="text" placeholder="Search and Hit enter"/>
      <button>🔍</button>
    </div>
    <div class="extra-box">
    </div>
  </div>
</section>

</>
  )
}

export default Blogcont